






























































/** У каждой оси свой токен отмены, а следующий уровень грузится по новому значению, не по пропу */
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import Toast from '@/mixins/toast';
// Импорт ради Array.prototype.realValuesOrEmpty() в зонных фильтрах
import '@/extensions';

import MmZoneSelect from '../../../components/MmZoneSelect.vue';

import { fetchStoreLevels } from '../../../api/catalog';
import { createCancelSource } from '../../../api/mmHttp';
import { isCanceled } from '../../../core/errors';
import { MmSelectOption } from '../../../types/domain';
import { MmStoreLevelsRequest } from '../../../types/dto';
import { MmTaskCreateZone } from '../buildTaskCreatePayload';

/** Имена осей должны совпадать со значениями MmStoreLevelsRequest.type */
type MmZoneAxis = 'format' | 'region' | 'cluster';

const ALL_VALUE = 0;

@Component({
	components: {
		MmZoneSelect,
	},
})
export default class ZoneBlock extends Mixins(Toast) {
	@Prop({ default: null }) readonly tradingId!: number | null;

	/** «Все» на любой оси — пустой массив; оставшийся сентинел 0 срезает prepareTaskFilters */
	@Prop({ required: true }) readonly value!: MmTaskCreateZone;

	@Prop({ default: false }) readonly disabled!: boolean;

	draft: MmTaskCreateZone = { formats: [], regions: [], clusters: [] };

	formatOptions: MmSelectOption[] = [];
	regionOptions: MmSelectOption[] = [];
	clusterOptions: MmSelectOption[] = [];

	isFormatsLoading: boolean = false;
	isRegionsLoading: boolean = false;
	isClustersLoading: boolean = false;

	private formatSource: any = null;
	private regionSource: any = null;
	private clusterSource: any = null;

	mounted(): void {
		this.syncDraftFromValue();
		this.loadInitialLevels();
	}

	beforeDestroy(): void {
		this.cancelPendingRequests();
	}

	@Watch('tradingId')
	onTradingIdChanged(next: number | null): void {
		this.cancelPendingRequests();
		this.formatOptions = [];
		this.regionOptions = [];
		this.clusterOptions = [];
		this.notifyFormatCatalog();

		if (this.hasAnySelection) {
			this.emitZone({ formats: [], regions: [], clusters: [] });
		}

		if (next === null) {
			return;
		}

		// Снимок пустой зоны, а не значение пропа: оно обновится только после эмита выше
		this.loadLevel('format', { formats: [], regions: [], clusters: [] });
	}

	get isNetworkMissing(): boolean {
		return this.tradingId === null;
	}

	get isAxisDisabled(): boolean {
		return this.disabled || this.isNetworkMissing;
	}

	get currentZone(): MmTaskCreateZone {
		const raw = this.value;

		return {
			formats: raw && Array.isArray(raw.formats) ? raw.formats.slice() : [],
			regions: raw && Array.isArray(raw.regions) ? raw.regions.slice() : [],
			clusters: raw && Array.isArray(raw.clusters) ? raw.clusters.slice() : [],
		};
	}

	get formatValue(): number[] {
		return this.draft.formats;
	}

	get regionValue(): number[] {
		return this.draft.regions;
	}

	get clusterValue(): number[] {
		return this.draft.clusters;
	}

	get hasAnySelection(): boolean {
		const zone = this.currentZone;

		return zone.formats.length > 0 || zone.regions.length > 0 || zone.clusters.length > 0;
	}

	get hasPendingChanges(): boolean {
		return !this.zonesEqual(this.draft, this.currentZone);
	}

	get formatPlaceholder(): string {
		return this.isFormatsLoading ? (this.$t('regular.loading.formatsChannels') as string) : '';
	}

	get regionPlaceholder(): string {
		return this.isRegionsLoading ? (this.$t('regular.loading.regions') as string) : '';
	}

	get clusterPlaceholder(): string {
		return this.isClustersLoading ? (this.$t('regular.loading.clusters') as string) : '';
	}

	/** Сравниваем отсортированные копии: MultiSelect шлёт событие и на программную установку — иначе цикл */
	@Watch('value', { deep: true })
	onValueChanged(): void {
		this.syncDraftFromValue();
	}

	handleFormatChange(next: number[]): void {
		const value = next ? next.slice() : [];

		if (this.isSameIdList(value, this.formatValue)) {
			return;
		}

		const zone: MmTaskCreateZone = { formats: value, regions: [], clusters: [] };

		this.patchDraft(zone);
		this.loadLevel('region', zone);
		this.loadLevel('cluster', zone);
	}

	handleRegionChange(next: number[]): void {
		const value = next ? next.slice() : [];

		if (this.isSameIdList(value, this.regionValue)) {
			return;
		}

		const zone: MmTaskCreateZone = {
			formats: this.draft.formats.slice(),
			regions: value,
			clusters: [],
		};

		this.patchDraft(zone);
		this.loadLevel('cluster', zone);
	}

	handleClusterChange(next: number[]): void {
		const value = next ? next.slice() : [];

		if (this.isSameIdList(value, this.clusterValue)) {
			return;
		}

		this.patchDraft({
			formats: this.draft.formats.slice(),
			regions: this.draft.regions.slice(),
			clusters: value,
		});
	}

	/** Грузим все уровни, а не один формат: блок может смонтироваться заново с заполненной зоной */
	private loadInitialLevels(): void {
		if (this.tradingId === null) {
			return;
		}

		const zone = this.draft;

		this.loadLevel('format', zone);
		this.loadLevel('region', zone);
		this.loadLevel('cluster', zone);
	}

	/** Родители уходят без сентинела 0 («Все»): иначе бэкенд примет его за идентификатор */
	private buildLevelsRequest(axis: MmZoneAxis, zone: MmTaskCreateZone): MmStoreLevelsRequest {
		const formats = zone.formats.slice().realValuesOrEmpty();
		const regions = zone.regions.slice().realValuesOrEmpty();

		return {
			tradingNetworkId: this.tradingId as number,
			type: axis,
			storeFormat: axis === 'format' ? [] : formats,
			storeRegion: axis === 'cluster' ? regions : [],
			storeCluster: [],
		};
	}

	/** Ось передаётся параметром: проп обновится позже, и this.value дал бы запрос по прежнему выбору */
	private loadLevel(axis: MmZoneAxis, zone: MmTaskCreateZone): void {
		if (this.tradingId === null) {
			return;
		}

		const previous = this.readSource(axis);

		if (previous !== null) {
			previous.cancel();
		}

		const source = createCancelSource();

		this.writeSource(axis, source);
		this.setAxisLoading(axis, true);

		fetchStoreLevels(this.buildLevelsRequest(axis, zone), { cancelToken: source.token })
			.then((response) => {
				if (this.readSource(axis) !== source) {
					return;
				}

				const data = response.data;
				const items = data && Array.isArray(data.items) ? data.items : [];

				if (items.length === 0) {
					this.applyAxisFallback(axis);

					return;
				}

				this.setAxisOptions(axis, items);
			})
			.catch((error) => {
				if (isCanceled(error)) {
					return;
				}

				if (this.readSource(axis) !== source) {
					return;
				}

				this.applyAxisFallback(axis);

				this.showError(this.$t('http.errors.loadFilters3') as string);
			})
			.finally(() => {
				if (this.readSource(axis) !== source) {
					return;
				}

				this.writeSource(axis, null);
				this.setAxisLoading(axis, false);
			});
	}

	/** Пустой и ошибочный ответ сбрасывают ось одинаково; сообщение об ошибке — только в catch */
	private applyAxisFallback(axis: MmZoneAxis): void {
		this.setAxisOptions(axis, this.buildAllOnlyOptions());
	}

	private buildAllOnlyOptions(): MmSelectOption[] {
		return [{ value: ALL_VALUE, label: this.$t('shared.selectBox.all') as string }];
	}

	private readSource(axis: MmZoneAxis): any {
		if (axis === 'format') {
			return this.formatSource;
		}

		if (axis === 'region') {
			return this.regionSource;
		}

		return this.clusterSource;
	}

	private writeSource(axis: MmZoneAxis, source: any): void {
		if (axis === 'format') {
			this.formatSource = source;

			return;
		}

		if (axis === 'region') {
			this.regionSource = source;

			return;
		}

		this.clusterSource = source;
	}

	private setAxisOptions(axis: MmZoneAxis, items: MmSelectOption[]): void {
		if (axis === 'format') {
			this.formatOptions = items;
			this.notifyFormatCatalog();

			return;
		}

		if (axis === 'region') {
			this.regionOptions = items;

			return;
		}

		this.clusterOptions = items;
	}

	private setAxisLoading(axis: MmZoneAxis, value: boolean): void {
		if (axis === 'format') {
			this.isFormatsLoading = value;
			if (value) {
				this.notifyFormatCatalog();
			}

			return;
		}

		if (axis === 'region') {
			this.isRegionsLoading = value;

			return;
		}

		this.isClustersLoading = value;
	}

	private notifyFormatCatalog(): void {
		if (this.isFormatsLoading) {
			this.$emit('formats-catalog', null);

			return;
		}

		const ids: number[] = [];

		for (let i = 0; i < this.formatOptions.length; i++) {
			const value = this.formatOptions[i].value;

			if (value !== 0) {
				ids.push(value);
			}
		}

		this.$emit('formats-catalog', ids);
	}

	private cancelPendingRequests(): void {
		if (this.formatSource !== null) {
			this.formatSource.cancel();
			this.formatSource = null;
		}

		if (this.regionSource !== null) {
			this.regionSource.cancel();
			this.regionSource = null;
		}

		if (this.clusterSource !== null) {
			this.clusterSource.cancel();
			this.clusterSource = null;
		}

		this.isFormatsLoading = false;
		this.isRegionsLoading = false;
		this.isClustersLoading = false;
	}

	takeDraft(): MmTaskCreateZone {
		return {
			formats: this.draft.formats.slice(),
			regions: this.draft.regions.slice(),
			clusters: this.draft.clusters.slice(),
		};
	}

	resetDraft(): void {
		this.syncDraftFromValue();
		this.loadInitialLevels();
	}

	private emitZone(zone: MmTaskCreateZone): void {
		const next: MmTaskCreateZone = {
			formats: zone.formats.slice(),
			regions: zone.regions.slice(),
			clusters: zone.clusters.slice(),
		};

		this.$emit('change', next);
	}

	private patchDraft(zone: MmTaskCreateZone): void {
		this.draft = {
			formats: zone.formats.slice(),
			regions: zone.regions.slice(),
			clusters: zone.clusters.slice(),
		};
		this.notifyPending();
	}

	private syncDraftFromValue(): void {
		this.draft = {
			formats: this.currentZone.formats.slice(),
			regions: this.currentZone.regions.slice(),
			clusters: this.currentZone.clusters.slice(),
		};
		this.notifyPending();
	}

	private notifyPending(): void {
		this.$emit('pending-change', this.hasPendingChanges);
		this.$emit('draft-change', this.takeDraft());
	}

	private zonesEqual(left: MmTaskCreateZone, right: MmTaskCreateZone): boolean {
		return this.isSameIdList(left.formats, right.formats)
			&& this.isSameIdList(left.regions, right.regions)
			&& this.isSameIdList(left.clusters, right.clusters);
	}

	private isSameIdList(a: number[], b: number[]): boolean {
		if (a.length !== b.length) {
			return false;
		}

		const left = a.slice().sort();
		const right = b.slice().sort();

		for (let i = 0; i < left.length; i += 1) {
			if (left[i] !== right[i]) {
				return false;
			}
		}

		return true;
	}
}
